<ng-container *ngIf="viewModel$ | async as viewModel">
  <div *ngIf="viewModel.loaded; else loading" class="header-wrapper">
    <header *ngIf="viewModel.job">
      <app-job-header-details></app-job-header-details>
      <div class="jobActions">
        <p-button
          *ngIf="viewModel.unsavedChanges"
          label="Save"
          [icon]="viewModel.saveChangesButtonIcon"
          (click)="store.dispatch(actions.saveButtonClicked())"
          [pTooltip]="viewModel.saveTooltipText"
          [disabled]="viewModel.saveChangesButtonDisabled"
          tooltipPosition="left"
        ></p-button>
        <p-button
          class="editJobButton"
          [label]="viewModel.editJobLabel"
          icon="pi pi-receipt"
          [routerLink]="viewModel.editJobRouterLink"
          queryParamsHandling="merge"
          [outlined]="true"
        ></p-button>
        <p-button
          icon="pi pi-ellipsis-v"
          [text]="true"
          (onClick)="menu.toggle($event)"
        />
      </div>
    </header>
  </div>

  <p-menu #menu [model]="viewModel.actionMenuItems" [popup]="true" />
  <!-- Footer for mobile view -->
  <a
    *ngIf="viewModel.job && !viewModel.unsavedChanges"
    class="mobile-footer"
    [routerLink]="viewModel.editJobRouterLink"
  >
    <div
      class="footer-button {{ viewModel.job.closedAt ? 'closed' : 'open' }} {{
        viewModel.job.stage
      }}"
    >
      <i class="pi pi-receipt"></i>
      <span>
        {{ viewModel.editJobLabel }}
      </span>
    </div>
  </a>

  <button
    *ngIf="viewModel.job && viewModel.unsavedChanges"
    type="button"
    class="mobile-footer"
    [disabled]="viewModel.saveChangesButtonDisabled"
    (click)="store.dispatch(actions.saveJobFooterClicked())"
  >
    <div class="footer-button open">
      <i [class]="viewModel.saveChangesButtonIcon"></i>
      <span> Save Job </span>
    </div>
  </button>

  <ng-template #loading>
    <div>
      <header>
        <div class="customerDetails">
          <div class="firstRow">
            <p-skeleton width="12rem" height="3rem"></p-skeleton>
          </div>
          <div class="secondRow">
            <p-skeleton width="20rem" height="1rem"></p-skeleton>
          </div>
        </div>
        <div class="jobActions">
          <p-skeleton width="7rem" height="3rem"></p-skeleton>
        </div>
      </header>
    </div>
  </ng-template>
</ng-container>
